export default class Constants {

    static LanguageTokenName = "language-token-name";
    static LANGUAGEClassName = "rtl2";
    static SiteDefaultTitle = "Job Flow Connect"
    static SiteDefaultDescription = "Job Flow Connect, Find jobs around the world"
    static baseUrl = "https://jobflowconnect.com/api/"

}